import React, { useEffect, useState } from "react";
import InjuryCalculator from "@/components/InjuryCalculator";
import AutoLiabilityCalculator from "@/components/AutoLiabilityCalculator";
import PremiumCalculator from "@/components/PremiumCalculator";
import SickLeaveCalculator from "@/components/SickLeaveCalculator";
import { Stethoscope, Car, Calculator, BriefcaseMedical } from "lucide-react";

const TABS = [
  { id: "premium", label: "Premija zavarovanja", icon: Calculator },
  { id: "injury", label: "Telesna poškodba / invalidnost", icon: Stethoscope },
  { id: "auto", label: "Prometne nesreče (AO, AO plus)", icon: Car },
  { id: "sick", label: "Izguba zaradi bolovanja", icon: BriefcaseMedical },
];

export default function Calculators() {
  const [tab, setTab] = useState("premium");

  useEffect(() => {
    const handler = (e) => {
      const id = e?.detail?.tab;
      if (TABS.find((t) => t.id === id)) setTab(id);
    };
    window.addEventListener("vp:set-calc-tab", handler);
    return () => window.removeEventListener("vp:set-calc-tab", handler);
  }, []);
  return (
    <section
      id="kalkulatorji"
      data-testid="calculators-section"
      className="py-24 md:py-32"
      style={{ background: "var(--vp-bg)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <div className="text-sm font-semibold tracking-widest uppercase text-[var(--vp-primary)] mb-3">
            Kalkulatorji
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
            Izračunaj. Premisli. Skleni.
          </h2>
          <p className="mt-5 text-[var(--vp-muted)] leading-relaxed">
            Sestavite si paket zavarovanja in spremljajte mesečno premijo v živo. Hitra
            ocena odškodnine pa je samo dva klika stran.
          </p>
        </div>

        <div className="inline-flex flex-wrap gap-1.5 p-1.5 rounded-3xl sm:rounded-full border border-[var(--vp-border)] bg-white mb-10">
          {TABS.map((t) => {
            const Icon = t.icon;
            const active = tab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                data-testid={`calc-tab-${t.id}`}
                className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-colors"
                style={
                  active
                    ? { background: "var(--vp-primary)", color: "white" }
                    : { color: "var(--vp-muted)" }
                }
              >
                <Icon size={16} /> {t.label}
              </button>
            );
          })}
        </div>

        <div className="rounded-3xl border border-[var(--vp-border)] bg-white p-7 md:p-10">
          {tab === "premium" && <PremiumCalculator />}
          {tab === "injury" && <InjuryCalculator />}
          {tab === "auto" && <AutoLiabilityCalculator />}
          {tab === "sick" && <SickLeaveCalculator />}
        </div>
      </div>
    </section>
  );
}
